var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _ellipse3, _ellipse4, _g, _g2, _g3, _mask, _g4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHailN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 454,
    height: 496,
    fill: "none",
    viewBox: "0 0 454 496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter0_f_30_670)",
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial_30_670)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M255.163 464.382C250.737 472.751 241.766 478.477 231.42 478.477C216.685 478.477 204.74 466.865 204.74 452.542C204.74 450.488 204.976 448.412 205.425 446.304C203.278 451.289 202.072 456.046 202.072 460.689C202.072 475.012 214.017 486.624 228.752 486.624C242.197 486.624 253.319 476.956 255.163 464.382Z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial_30_670)",
    d: "M255.165 460.561C255.165 474.884 243.22 486.495 228.485 486.495C213.75 486.495 201.806 474.884 201.806 460.561C201.806 446.237 213.278 430.824 228.485 411C241.291 430.281 255.165 446.237 255.165 460.561Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.288,
    cy: 439.243,
    fill: "url(#paint2_radial_30_670)",
    rx: 27.346,
    ry: 27.157
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.814,
    cy: 468.843,
    fill: "url(#paint3_radial_30_670)",
    rx: 27.346,
    ry: 27.157
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    filter: "url(#filter1_f_30_670)",
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_radial_30_670)",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M152.047 402.566C148.886 408.769 142.478 413.012 135.088 413.012C124.563 413.012 116.031 404.406 116.031 393.79C116.031 392.268 116.2 390.729 116.52 389.166C114.986 392.861 114.125 396.387 114.125 399.828C114.125 410.444 122.658 419.05 133.182 419.05C142.786 419.05 150.73 411.885 152.047 402.566Z",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_radial_30_670)",
    d: "M152.048 399.733C152.048 410.349 143.516 418.955 132.991 418.955C122.467 418.955 113.935 410.349 113.935 399.733C113.935 389.117 122.129 377.693 132.991 363C142.139 377.291 152.048 389.117 152.048 399.733Z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.851,
    cy: 383.933,
    fill: "url(#paint6_radial_30_670)",
    rx: 19.533,
    ry: 20.128
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.798,
    cy: 405.872,
    fill: "url(#paint7_radial_30_670)",
    rx: 19.533,
    ry: 20.128
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_30_670)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 87.388,
    y1: -7.5,
    y2: -7.5,
    stroke: "url(#paint8_linear_30_670)",
    strokeLinecap: "round",
    strokeWidth: 15,
    transform: "matrix(-0.422558 0.906336 -0.907105 -0.420905 308.095 356)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_30_670)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 87.388,
    y1: -7.5,
    y2: -7.5,
    stroke: "url(#paint9_linear_30_670)",
    strokeLinecap: "round",
    strokeWidth: 15,
    transform: "matrix(-0.422558 0.906336 -0.907105 -0.420905 202.492 352)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_30_670)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_30_670)",
    fillRule: "evenodd",
    d: "M361.51 1.0861C356.359 0.370139 351.096 0 345.747 0C283.345 0 232.758 50.368 232.758 112.5C232.758 174.632 283.345 225 345.747 225C392.679 225 432.929 196.509 450 155.95C448.898 155.983 447.793 156 446.683 156C389.689 156 343.487 111.676 343.487 57C343.487 36.2527 350.14 16.996 361.51 1.0861Z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_30_670",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 354L150.358 354C67.3176 354 0 286.843 0 204C0 121.157 67.3176 54 150.358 54C217.131 54 273.738 97.4226 293.354 157.507C301.767 155.22 310.622 154 319.761 154C375.122 154 420 198.771 420 254C420 309.228 375.122 354 319.761 354Z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_30_670)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_30_670)",
    fillRule: "evenodd",
    d: "M319.761 354L150.358 354C67.3176 354 0 286.843 0 204C0 121.157 67.3176 54 150.358 54C217.131 54 273.738 97.4226 293.354 157.507C301.767 155.22 310.622 154 319.761 154C375.122 154 420 198.771 420 254C420 309.228 375.122 354 319.761 354Z",
    clipRule: "evenodd"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 354V353V354ZM319.761 354V355V354ZM293.354 157.507L292.403 157.817L292.698 158.721L293.616 158.472L293.354 157.507ZM150.358 355L319.761 355V353L150.358 353V355ZM-1 204C-1 287.397 66.7675 355 150.358 355V353C67.8676 353 1 286.288 1 204H-1ZM150.358 53C66.7675 53 -1 120.603 -1 204H1C1 121.712 67.8676 55 150.358 55V53ZM294.304 157.196C274.558 96.7118 217.575 53 150.358 53V55C216.687 55 272.918 98.1334 292.403 157.817L294.304 157.196ZM293.616 158.472C301.945 156.208 310.711 155 319.761 155V153C310.532 153 301.59 154.232 293.091 156.542L293.616 158.472ZM319.761 155C374.572 155 419 199.326 419 254H421C421 198.217 375.672 153 319.761 153V155ZM419 254C419 308.674 374.572 353 319.761 353V355C375.672 355 421 309.783 421 254H419Z",
    mask: "url(#path-12-inside-1_30_670)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_30_670",
    width: 69.091,
    height: 56.32,
    x: 194.072,
    y: 438.304,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_670",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_30_670",
    width: 53.922,
    height: 45.884,
    x: 106.125,
    y: 381.166,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_670",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_30_670",
    width: 52.771,
    height: 91.398,
    x: 268.465,
    y: 356.458,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_670",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_30_670",
    width: 52.771,
    height: 91.398,
    x: 162.862,
    y: 352.458,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_30_670",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_30_670",
    width: 246.241,
    height: 240,
    x: 207.758,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_30_670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_670",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -25,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.529412 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect2_innerShadow_30_670"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_30_670",
    width: 420,
    height: 348.647,
    x: 0,
    y: 54,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_30_670"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(228.752 462.454) rotate(-38.1866) scale(44.8052 32.3736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(228.485 462.326) rotate(-38.1866) scale(44.8052 32.3736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(235.288 439.243) rotate(56.4667) scale(38.1172 11.064)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(218.347 468.843) rotate(50.2202) scale(20.8486 10.104)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(133.182 401.137) rotate(-39.2197) scale(32.4694 23.6503)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(132.991 401.042) rotate(-39.2198) scale(32.4695 23.6504)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3CC7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(137.851 383.933) rotate(57.4345) scale(27.9428 7.9902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_30_670",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(125.75 405.872) rotate(51.2577) scale(15.2255 7.32477)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#BDDBF1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5686F5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_30_670",
    x1: 0.207,
    x2: 71.759,
    y1: 0.446,
    y2: 1.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_30_670",
    x1: 0.207,
    x2: 71.759,
    y1: 0.446,
    y2: 1.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_30_670",
    x1: 245.564,
    x2: 408.013,
    y1: 0,
    y2: 257.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B87EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#3010AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_30_670",
    x1: 29.423,
    x2: 419.459,
    y1: 54,
    y2: 354.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHailN);
export default __webpack_public_path__ + "static/media/hailN.7d81300cdf0f07870eafbcd10f5269b6.svg";
export { ForwardRef as ReactComponent };